module.exports = __webpack_public_path__ + "img/14.bc7daf1f.png";